import React from 'react'
import { useStaticQuery, graphql } from 'gatsby'
import styled from 'styled-components'
import { color, opacity, transition } from '@configs/utilities'
import { injectIntl, Link } from 'gatsby-plugin-react-intl'
import productTourIcon from '@assets/images/navbar/megaMenu/productTourIcon.svg'

const NavbarMegaMenu = ({ intl }) => {
  const data = useStaticQuery(graphql`
    query {
      allNavbarMegaJson {
        edges {
          node {
            head
            submenu {
              path
              text
              icon {
                publicURL
              }
            }
          }
        }
      }
    }
  `)

  return (
    <Wrapper>
      <Head>
        <img src={productTourIcon} alt="Product tour icon" />
        <p className="headTitle">{intl.formatMessage({ id: 'megaMenu.title' })}</p>
        <p className="headDescription">{intl.formatMessage({ id: 'megaMenu.description' })}</p>
        <Link className="headLearnMore" to="/features/product-tour/">
          {intl.formatMessage({ id: 'megaMenu.learnMore' })}
          <span>>></span>
        </Link>
      </Head>
      <LinkWrapper>
        {data.allNavbarMegaJson.edges.map((item, index) => {
          return (
            <div key={index}>
              <LinkTitle>{intl.formatMessage({ id: item.node.head })}</LinkTitle>
              {item.node.submenu.map((item, index) => {
                return (
                  <MenuLink key={index} to={item.path} activeClassName="activeSubmenuLink">
                    <img src={item.icon.publicURL} alt="icon" />
                    <span>{intl.formatMessage({ id: item.text })}</span>
                  </MenuLink>
                )
              })}
            </div>
          )
        })}
      </LinkWrapper>
    </Wrapper>
  )
}

export default injectIntl(NavbarMegaMenu)

const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  align-items: flex-start;
  width: 100%;
  padding: 10px 20px 30px;
`

const Head = styled.div`
  width: 100%;
  min-width: 230px;
  max-width: 230px;

  .headTitle {
    color: ${color.font};
    font-size: 22px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }
  .headDescription {
    color: rgba(8, 30, 74, 0.6);
    font-size: 15px;
    font-style: normal;
    font-weight: 300;
    line-height: normal;
    width: 170px;
  }

  a {
    color: ${color.blue} !important;
    font-size: 15px;
    font-weight: 400;
    transition: ${transition.default};

    @media (hover: hover) {
      &:hover {
        opacity: ${opacity.default};

        span {
          margin-left: 10px;
          transition: ${transition.default};
        }
      }
    }

    span {
      margin-left: 5px;
    }
  }
`

const LinkWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  column-gap: 60px;
  width: 100%;
`

const LinkTitle = styled.div`
  color: rgba(8, 30, 74, 0.5);
  text-align: left;
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 14px;
  padding-left: 15px;
`
const MenuLink = styled(Link)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  column-gap: 10px;
  row-gap: 5px;
  color: ${color.font};
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  width: 100%;
  flex-direction: row;
  border-radius: 8px;
  padding: 3px 15px;
  transition: ${transition.default};

  &:hover {
    opacity: ${opacity.default};
    background: #deebff;
    color: ${color.blue};
  }
`
